/* BI-11 · PLAN-CHANGE PREVIEW
   The exact arithmetic is shown before any payment; annual → monthly takes
   effect at the term, without penalty. */
import { Button, Card, KV, Note } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI11Annuel() {
  const p = useBill().planChange
  return (
    <section data-frame="BI-11" style={{ display: 'grid', gap: 14 }}>
      <Head title={`Passer à ${p.plan} annuel`} />
      <Card>
        <KV rows={[
          ['Aujourd’hui', p.today],
          ['Après', <strong>{`${p.after} (${p.off})`}</strong>],
          ['Aujourd’hui vous payez', <><strong>{p.dueToday}</strong>{p.dueTodayTail}</>],
          ['Prochaine échéance', p.nextDate],
        ]} />
      </Card>
      <Note tone="ok">
        Le calcul exact est affiché avant tout paiement. Un passage annuel → mensuel prend effet à
        l’échéance, sans pénalité.
      </Note>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="quiet">Annuler</Button>
        <Button variant="primary">Confirmer — {p.dueToday}</Button>
      </div>
    </section>
  )
}
